var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative" },
    [
      _c(
        "el-card",
        {
          directives: [
            {
              name: "hasPermi",
              rawName: "v-hasPermi",
              value: ["platform:user:page:list"],
              expression: "['platform:user:page:list']",
            },
          ],
          staticClass: "ivu-mt",
          attrs: {
            bordered: false,
            shadow: "never",
            "body-style": { padding: 0 },
          },
        },
        [
          _c(
            "div",
            { staticClass: "padding-add" },
            [
              _c(
                "el-form",
                {
                  ref: "userFrom",
                  attrs: {
                    model: _vm.userFrom,
                    "label-width": "66px",
                    "label-position": "right",
                    inline: "",
                  },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  !_vm.collapse
                    ? _c(
                        "div",
                        { staticClass: "acea-row search-form" },
                        [
                          _c(
                            "div",
                            { staticClass: "search-form-box" },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "用户搜索：",
                                    "label-for": "nickname",
                                  },
                                },
                                [
                                  _c("UserSearchInput", {
                                    model: {
                                      value: _vm.userFrom,
                                      callback: function ($$v) {
                                        _vm.userFrom = $$v
                                      },
                                      expression: "userFrom",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "用户标签：" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "selWidth",
                                      attrs: {
                                        placeholder: "请选择",
                                        clearable: "",
                                        filterable: "",
                                        multiple: "",
                                        size: "small",
                                      },
                                      model: {
                                        value: _vm.labelData,
                                        callback: function ($$v) {
                                          _vm.labelData =
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                        },
                                        expression: "labelData",
                                      },
                                    },
                                    _vm._l(
                                      _vm.labelLists,
                                      function (item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            value: item.id,
                                            label: item.name,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { staticClass: "search-form-sub" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "small" },
                                  on: { click: _vm.userSearchs },
                                },
                                [_vm._v("搜索")]
                              ),
                              _c(
                                "el-button",
                                {
                                  staticClass: "ResetSearch",
                                  attrs: { size: "small" },
                                  on: { click: _vm.reset },
                                },
                                [_vm._v("重置")]
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "ivu-ml-8 font12 ml10",
                                  on: {
                                    click: function ($event) {
                                      _vm.collapse = !_vm.collapse
                                    },
                                  },
                                },
                                [
                                  !_vm.collapse
                                    ? [
                                        _vm._v(" 展开 "),
                                        _c("i", {
                                          staticClass: "el-icon-arrow-down",
                                        }),
                                      ]
                                    : [
                                        _vm._v(" 收起 "),
                                        _c("i", {
                                          staticClass: "el-icon-arrow-up",
                                        }),
                                      ],
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.collapse
                    ? _c(
                        "div",
                        { staticClass: "acea-row search-form" },
                        [
                          _c(
                            "div",
                            { staticClass: "search-form-box" },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "用户搜索：",
                                    "label-for": "nickname",
                                  },
                                },
                                [
                                  _c("UserSearchInput", {
                                    model: {
                                      value: _vm.userFrom,
                                      callback: function ($$v) {
                                        _vm.userFrom = $$v
                                      },
                                      expression: "userFrom",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "用户标签：" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "selWidth",
                                      attrs: {
                                        placeholder: "请选择",
                                        clearable: "",
                                        filterable: "",
                                        multiple: "",
                                        size: "small",
                                      },
                                      model: {
                                        value: _vm.labelData,
                                        callback: function ($$v) {
                                          _vm.labelData =
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                        },
                                        expression: "labelData",
                                      },
                                    },
                                    _vm._l(
                                      _vm.labelLists,
                                      function (item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            value: item.id,
                                            label: item.name,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "消费情况：" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "selWidth",
                                      attrs: {
                                        placeholder: "请选择",
                                        size: "small",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.userFrom.payCount,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.userFrom,
                                            "payCount",
                                            $$v
                                          )
                                        },
                                        expression: "userFrom.payCount",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { value: "0", label: "0" },
                                      }),
                                      _c("el-option", {
                                        attrs: { value: "1", label: "1+" },
                                      }),
                                      _c("el-option", {
                                        attrs: { value: "2", label: "2+" },
                                      }),
                                      _c("el-option", {
                                        attrs: { value: "3", label: "3+" },
                                      }),
                                      _c("el-option", {
                                        attrs: { value: "4", label: "4+" },
                                      }),
                                      _c("el-option", {
                                        attrs: { value: "5", label: "5+" },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "用户性别：" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "selWidth",
                                      attrs: {
                                        placeholder: "请选择",
                                        size: "small",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.userFrom.sex,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.userFrom, "sex", $$v)
                                        },
                                        expression: "userFrom.sex",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { value: "", label: "全部" },
                                      }),
                                      _c("el-option", {
                                        attrs: { value: "0", label: "未知" },
                                      }),
                                      _c("el-option", {
                                        attrs: { value: "1", label: "男" },
                                      }),
                                      _c("el-option", {
                                        attrs: { value: "2", label: "女" },
                                      }),
                                      _c("el-option", {
                                        attrs: { value: "3", label: "保密" },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "用户身份：" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "selWidth",
                                      attrs: {
                                        placeholder: "请选择",
                                        size: "small",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.userFrom.identity,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.userFrom,
                                            "identity",
                                            $$v
                                          )
                                        },
                                        expression: "userFrom.identity",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { value: "", label: "全部" },
                                      }),
                                      _c("el-option", {
                                        attrs: { value: "1", label: "推广员" },
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          value: "3",
                                          label: "付费会员",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "时间选择：" } },
                                [
                                  _c("el-date-picker", {
                                    staticClass: "selWidth",
                                    attrs: {
                                      align: "right",
                                      "unlink-panels": "",
                                      "value-format": "yyyy-MM-dd",
                                      format: "yyyy-MM-dd",
                                      size: "small",
                                      type: "daterange",
                                      placement: "bottom-end",
                                      placeholder: "自定义时间",
                                      "picker-options": _vm.pickerOptions,
                                    },
                                    on: { change: _vm.onchangeTime },
                                    model: {
                                      value: _vm.timeVal,
                                      callback: function ($$v) {
                                        _vm.timeVal = $$v
                                      },
                                      expression: "timeVal",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "注册类型：" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "selWidth",
                                      attrs: {
                                        placeholder: "请选择",
                                        size: "small",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.userFrom.registerType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.userFrom,
                                            "registerType",
                                            $$v
                                          )
                                        },
                                        expression: "userFrom.registerType",
                                      },
                                    },
                                    _vm._l(
                                      _vm.registerTypeList,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.label,
                                            value: item.value,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { staticClass: "search-form-sub" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "small" },
                                  on: { click: _vm.userSearchs },
                                },
                                [_vm._v("搜索")]
                              ),
                              _c(
                                "el-button",
                                {
                                  staticClass: "ResetSearch",
                                  attrs: { size: "small" },
                                  on: { click: _vm.reset },
                                },
                                [_vm._v("重置")]
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "ivu-ml-8 font12 ml10",
                                  on: {
                                    click: function ($event) {
                                      _vm.collapse = !_vm.collapse
                                    },
                                  },
                                },
                                [
                                  !_vm.collapse
                                    ? [
                                        _vm._v(" 展开 "),
                                        _c("i", {
                                          staticClass: "el-icon-arrow-down",
                                        }),
                                      ]
                                    : [
                                        _vm._v(" 收起 "),
                                        _c("i", {
                                          staticClass: "el-icon-arrow-up",
                                        }),
                                      ],
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            "body-style": { padding: "20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _c(
            "div",
            { staticClass: "acea-row row-middle" },
            [
              _c(
                "el-dropdown",
                { attrs: { size: "small" } },
                [
                  _c(
                    "el-button",
                    { attrs: { disabled: !_vm.multipleSelectionAll.length } },
                    [
                      _vm._v(" 批量设置"),
                      _c("i", {
                        staticClass: "el-icon-arrow-down el-icon--right",
                      }),
                    ]
                  ),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _vm.multipleSelectionAll.length
                        ? [
                            _c(
                              "el-dropdown-item",
                              {
                                directives: [
                                  {
                                    name: "hasPermi",
                                    rawName: "v-hasPermi",
                                    value: ["platform:user:tag"],
                                    expression: "['platform:user:tag']",
                                  },
                                ],
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.setBatch("label", "", 1)
                                  },
                                },
                              },
                              [_vm._v("批量添加标签")]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                directives: [
                                  {
                                    name: "hasPermi",
                                    rawName: "v-hasPermi",
                                    value: [
                                      "platform:coupon:can:send:list",
                                      "platform:coupon:batch:send",
                                    ],
                                    expression:
                                      "['platform:coupon:can:send:list', 'platform:coupon:batch:send']",
                                  },
                                ],
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.sendCoupon($event)
                                  },
                                },
                              },
                              [_vm._v("发送优惠券")]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                directives: [
                                  {
                                    name: "hasPermi",
                                    rawName: "v-hasPermi",
                                    value: ["platform:user:gift:paid:member"],
                                    expression:
                                      "['platform:user:gift:paid:member']",
                                  },
                                ],
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.handleGiftMembers("")
                                  },
                                },
                              },
                              [_vm._v("赠送会员")]
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.multipleSelectionAll.length,
                      expression: "multipleSelectionAll.length",
                    },
                  ],
                  staticClass: "ml12 font12",
                },
                [
                  _vm._v(" 已选 "),
                  _c("span", { staticClass: "font-color font12" }, [
                    _vm._v(" " + _vm._s(_vm.multipleSelectionAll.length) + " "),
                  ]),
                  _vm._v("项 "),
                  _c(
                    "span",
                    {
                      staticClass: "ml12 pointer",
                      on: { click: _vm.handleResetSelection },
                    },
                    [_vm._v("清空")]
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              ref: "table",
              staticClass: "mt20",
              attrs: {
                data: _vm.tableData.data,
                size: "small",
                "highlight-current-row": "",
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "expand", width: "40" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c(
                          "el-form",
                          {
                            staticClass: "demo-table-expand",
                            attrs: { "label-position": "left", inline: "" },
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "首次访问：" } },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("filterEmpty")(
                                        props.row.createTime
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: "近次访问：" } },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("filterEmpty")(
                                        props.row.lastLoginTime
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _c("el-form-item", { attrs: { label: "标签：" } }, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm._f("tagFilter")(props.row.tagId))
                                ),
                              ]),
                            ]),
                            _c("el-form-item", { attrs: { label: "地址：" } }, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("filterEmpty")(
                                      props.row.province + props.row.city
                                    )
                                  )
                                ),
                              ]),
                            ]),
                            _c(
                              "el-form-item",
                              {
                                staticStyle: {
                                  width: "100%",
                                  display: "flex",
                                  "margin-right": "10px",
                                },
                                attrs: { label: "备注：" },
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("filterEmpty")(props.row.mark)
                                    )
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { type: "selection", width: "45" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "userNumber",
                  label: "用户编号",
                  width: "120",
                  align: "right",
                },
              }),
              _vm.checkedCities.includes("头像")
                ? _c("el-table-column", {
                    attrs: { label: "头像", width: "50" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "demo-image__preview line-heightOne",
                                },
                                [
                                  _c("el-image", {
                                    attrs: {
                                      src: scope.row.avatar,
                                      "preview-src-list": [scope.row.avatar],
                                      fit: "cover",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      898244126
                    ),
                  })
                : _vm._e(),
              _vm.checkedCities.includes("姓名")
                ? _c("el-table-column", {
                    attrs: { label: "昵称", "min-width": "180" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "acea-row row-middle" },
                                [
                                  _c(
                                    "span",
                                    { class: scope.row.isLogoff ? "red" : "" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("filterEmpty")(
                                            scope.row.nickname
                                          )
                                        ) + " | "
                                      ),
                                    ]
                                  ),
                                  _c("img", {
                                    attrs: {
                                      src: _vm.getSexImage(scope.row.sex),
                                      title: _vm.sexFilter(scope.row.sex),
                                    },
                                  }),
                                  scope.row.isLogoff == true
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "ml2",
                                          class: scope.row.isLogoff
                                            ? "red"
                                            : "",
                                        },
                                        [_vm._v("|")]
                                      )
                                    : _vm._e(),
                                  scope.row.isLogoff
                                    ? _c("span", { staticClass: "red ml2" }, [
                                        _vm._v("(已注销)"),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3909109387
                    ),
                  })
                : _vm._e(),
              _vm.checkedCities.includes("推荐人")
                ? _c("el-table-column", {
                    attrs: { label: "推荐人", "min-width": "130" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("filterEmpty")(scope.row.spreadName)
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3565175388
                    ),
                  })
                : _vm._e(),
              _vm.checkedCities.includes("联系电话")
                ? _c("el-table-column", {
                    attrs: { label: "联系电话", "min-width": "100" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm._f("filterEmpty")(scope.row.phone))
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3743808278
                    ),
                  })
                : _vm._e(),
              _vm.checkedCities.includes("余额")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "nowMoney",
                      label: "余额",
                      "min-width": "100",
                    },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("积分")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "integral",
                      label: "积分",
                      "min-width": "100",
                    },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("注册类型")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "registerType",
                      label: "注册类型",
                      "min-width": "100",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("registerTypeFilter")(
                                      scope.row.registerType
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3340644063
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { label: "操作", width: "150", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.checkPermi(["platform:user:detail"])
                          ? _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.onDetails(scope.row.id)
                                  },
                                },
                              },
                              [_vm._v("详情")]
                            )
                          : _vm._e(),
                        _c("el-divider", { attrs: { direction: "vertical" } }),
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: [
                                  "platform:user:update",
                                  "platform:user:detail",
                                ],
                                expression:
                                  "['platform:user:update', 'platform:user:detail']",
                              },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.editUser(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _c("el-divider", { attrs: { direction: "vertical" } }),
                        _c(
                          "el-dropdown",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: [
                                  "platform:user:operate:integer",
                                  "platform:user:operate:balance",
                                  "platform:user:tag",
                                  "platform:retail:store:update:user:spread",
                                  "platform:retail:store:clean:user:spread",
                                  "platform:user:gift:paid:member",
                                ],
                                expression:
                                  "[\n              'platform:user:operate:integer',\n              'platform:user:operate:balance',\n              'platform:user:tag',\n              'platform:retail:store:update:user:spread',\n              'platform:retail:store:clean:user:spread',\n              'platform:user:gift:paid:member',\n            ]",
                              },
                            ],
                            attrs: { trigger: "click" },
                          },
                          [
                            _c("span", { staticClass: "el-dropdown-link" }, [
                              _vm._v(" 更多"),
                              _c("i", {
                                staticClass:
                                  "el-icon-arrow-down el-icon--right",
                              }),
                            ]),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                _vm.checkPermi([
                                  "platform:user:operate:integer",
                                ])
                                  ? _c(
                                      "el-dropdown-item",
                                      {
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.editPoint(
                                              scope.row,
                                              "integral"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("修改积分")]
                                    )
                                  : _vm._e(),
                                _vm.checkPermi([
                                  "platform:user:operate:balance",
                                ])
                                  ? _c(
                                      "el-dropdown-item",
                                      {
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.editPoint(
                                              scope.row,
                                              "balance"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("修改余额")]
                                    )
                                  : _vm._e(),
                                _vm.checkPermi(["platform:user:tag"])
                                  ? _c(
                                      "el-dropdown-item",
                                      {
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.setBatch(
                                              "label",
                                              scope.row,
                                              2
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("设置标签")]
                                    )
                                  : _vm._e(),
                                _vm.checkPermi([
                                  "platform:retail:store:update:user:spread",
                                ])
                                  ? _c(
                                      "el-dropdown-item",
                                      {
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.setExtension(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("修改上级推广人")]
                                    )
                                  : _vm._e(),
                                scope.row.spreadUid &&
                                scope.row.spreadUid > 0 &&
                                _vm.checkPermi([
                                  "platform:retail:store:clean:user:spread",
                                ])
                                  ? _c(
                                      "el-dropdown-item",
                                      {
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.clearSpread(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("清除上级推广人")]
                                    )
                                  : _vm._e(),
                                _vm.checkPermi([
                                  "platform:user:gift:paid:member",
                                ])
                                  ? _c(
                                      "el-dropdown-item",
                                      {
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.handleGiftMembers(
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("赠送会员")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "page-sizes": [20, 40, 60, 80],
                  "page-size": _vm.userFrom.limit,
                  "current-page": _vm.userFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.card_select_show,
              expression: "card_select_show",
            },
          ],
          staticClass: "card_abs",
          style: { top: _vm.collapse ? 570 + "px" : 270 + "px" },
        },
        [
          [
            _c(
              "div",
              { staticClass: "cell_ht" },
              [
                _c(
                  "el-checkbox",
                  {
                    attrs: { indeterminate: _vm.isIndeterminate },
                    on: { change: _vm.handleCheckAllChange },
                    model: {
                      value: _vm.checkAll,
                      callback: function ($$v) {
                        _vm.checkAll = $$v
                      },
                      expression: "checkAll",
                    },
                  },
                  [_vm._v("全选")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.checkSave()
                      },
                    },
                  },
                  [_vm._v("保存")]
                ),
              ],
              1
            ),
            _c(
              "el-checkbox-group",
              {
                on: { change: _vm.handleCheckedCitiesChange },
                model: {
                  value: _vm.checkedCities,
                  callback: function ($$v) {
                    _vm.checkedCities = $$v
                  },
                  expression: "checkedCities",
                },
              },
              _vm._l(_vm.columnData, function (item) {
                return _c(
                  "el-checkbox",
                  {
                    key: item,
                    staticClass: "check_cell",
                    attrs: { label: item },
                  },
                  [_vm._v(_vm._s(item))]
                )
              }),
              1
            ),
          ],
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "修改推广人",
            visible: _vm.extensionVisible,
            width: "540px",
            "before-close": _vm.handleCloseExtension,
          },
          on: {
            "update:visible": function ($event) {
              _vm.extensionVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "formExtension",
              staticClass: "formExtension mt20",
              attrs: {
                model: _vm.formExtension,
                rules: _vm.ruleInline,
                "label-width": "70px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "选择用户:", prop: "image" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "upLoadPicBox",
                      on: { click: _vm.modalPicTap },
                    },
                    [
                      _vm.selectedUser.image
                        ? _c("div", { staticClass: "acea-row" }, [
                            _c("img", {
                              staticClass: "pictrue",
                              attrs: { src: _vm.selectedUser.image },
                            }),
                            _c("span", [
                              _vm._v(_vm._s(_vm.selectedUser.nickname)),
                            ]),
                          ])
                        : _c("div", { staticClass: "upLoad" }, [
                            _c("i", {
                              staticClass: "el-icon-camera cameraIconfont",
                            }),
                          ]),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.extensionVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.onSubExtension("formExtension")
                    },
                  },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "big-dialog",
          attrs: {
            title: "推广员列表",
            visible: _vm.userVisible,
            width: "900px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.userVisible = $event
            },
          },
        },
        [
          _vm.userVisible
            ? _c("user-list", { on: { getTemplateRow: _vm.getTemplateRow } })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.isBatch ? "批量添加标签" : "设置标签",
            visible: _vm.dialogVisible,
            width: "540px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "dynamicValidateFormRef",
              staticClass: "demo-dynamic",
              attrs: { model: _vm.dynamicValidateForm, "label-width": "75px" },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "groupId",
                    label: "用户标签：",
                    rules: [
                      {
                        required: true,
                        message: "请选择用户标签",
                        trigger: "change",
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择标签",
                        filterable: "",
                        multiple: "",
                      },
                      model: {
                        value: _vm.dynamicValidateForm.groupId,
                        callback: function ($$v) {
                          _vm.$set(_vm.dynamicValidateForm, "groupId", $$v)
                        },
                        expression: "dynamicValidateForm.groupId",
                      },
                    },
                    _vm._l(_vm.labelLists, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { value: item.id, label: item.name },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "debounceClick",
                      rawName: "v-debounceClick",
                      value: function () {
                        _vm.submitForm("dynamicValidateFormRef")
                      },
                      expression:
                        "\n          () => {\n            submitForm('dynamicValidateFormRef');\n          }\n        ",
                    },
                  ],
                  attrs: { type: "primary" },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { title: "编辑", visible: _vm.visible, width: "900px" },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _vm.visible
            ? _c("edit-from", {
                staticClass: "dialog-bottom",
                attrs: { userInfo: _vm.userInfo },
                on: {
                  resetForm: _vm.resetForm,
                  success: _vm.handleEditSuccess,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.type === "integral" ? "积分" : "余额",
            visible: _vm.VisiblePoint,
            width: "540px",
            "close-on-click-modal": false,
            "before-close": _vm.handlePointClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.VisiblePoint = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingPoint,
                  expression: "loadingPoint",
                },
              ],
              ref: "PointValidateForm",
              staticClass: "demo-dynamic",
              attrs: { model: _vm.PointValidateForm, "label-width": "75px" },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.type === "integral" ? "积分：" : "余额：",
                    required: "",
                  },
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.type === "integral"
                          ? _vm.userInfo.integral
                          : _vm.userInfo.nowMoney
                      )
                    ),
                  ]),
                ]
              ),
              _vm.type === "integral"
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "修改积分：", required: "" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.PointValidateForm.operateType,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.PointValidateForm,
                                  "operateType",
                                  $$v
                                )
                              },
                              expression: "PointValidateForm.operateType",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: "add" } }, [
                              _vm._v("增加"),
                            ]),
                            _c("el-radio", { attrs: { label: "sub" } }, [
                              _vm._v("减少"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "积分：", required: "" } },
                      [
                        _c("el-input-number", {
                          attrs: {
                            type: "text",
                            "step-strictly": "",
                            min: 0,
                            max: 999999,
                          },
                          model: {
                            value: _vm.PointValidateForm.integral,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.PointValidateForm,
                                "integral",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "PointValidateForm.integral",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : [
                    _c(
                      "el-form-item",
                      { attrs: { label: "修改余额：", required: "" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.PointValidateForm.operateType,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.PointValidateForm,
                                  "operateType",
                                  $$v
                                )
                              },
                              expression: "PointValidateForm.operateType",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: "add" } }, [
                              _vm._v("增加"),
                            ]),
                            _c("el-radio", { attrs: { label: "sub" } }, [
                              _vm._v("减少"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "余额：", required: "" } },
                      [
                        _c("el-input-number", {
                          attrs: {
                            type: "text",
                            precision: 2,
                            step: 0.1,
                            min: 0,
                            max: 999999,
                          },
                          model: {
                            value: _vm.PointValidateForm.money,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.PointValidateForm,
                                "money",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "PointValidateForm.money",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
            ],
            2
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.handlePointClose } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loadingBtn },
                  on: {
                    click: function ($event) {
                      return _vm.submitPointForm("PointValidateForm")
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("detail-user", { ref: "userDetailFrom" }),
      _vm.visibleCoupon
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: "优惠券列表",
                visible: _vm.visibleCoupon,
                width: "1000px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.visibleCoupon = $event
                },
              },
            },
            [
              _vm.visibleCoupon
                ? _c("coupon-List", {
                    ref: "couponList",
                    attrs: { checkedIds: _vm.checkedIds },
                    on: { sendSuccess: _vm.sendSuccess },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.dialogVisibleMember
        ? _c("gift-to-members", {
            ref: "giftMembersRef",
            attrs: {
              tableDataMember: _vm.tableDataMember,
              dialogVisibleMember: _vm.dialogVisibleMember,
              checkedIds: _vm.checkeduIds.toString(),
            },
            on: {
              handlerSuccessSubmit: _vm.handlerSuccessSubmit,
              handlerSuccessClose: _vm.handlerSuccessSubmit,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }